const list = {
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-year",
        label: "대상년도",
        value: "year",
        query: { y: "year" },
        options: {
          default: new Date().getFullYear(),
          afterFix: "년",
        },
      },
      {
        component: "search-select-field",
        label: "사업장",
        value: "field",
        query: { f_id: "fieldId", f_name: "fieldName" },
        options: {
          default: { fieldId: "", fieldName: "" },
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: {
          hiddenList: ["사업장명", "대상년도", "재해일시", "근속년수", "해당직무근속년수", "복직일", "요양일수", "산재승인여부", "재해속보", "합동조사회의록", "재발방지대책", "개선결과", "위험성평가(개선전)", "위험성평가(개선후)"],
        },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    const year = search.year;
    conditions.push({ key: "header.year", operator: "=", value: `${year}` });

    // 사업장
    if (search.field) {
      conditions.push({ key: "body.stdInfo.field_id", operator: "=", value: search.field.fieldId });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  getDefaultSort: () => {
    return [{target: '$body.subInfo.재해일시', direction: 'desc'}];
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "대상년도",
        key: "header.year",
      },
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "구분",
        key: "body.subInfo.구분",
      },
      {
        name: "이름",
        key: "body.subInfo.이름",
      },
      {
        name: "팀명/업체명",
        key: "body.subInfo.팀명_업체명",
      },
      {
        name: "재해 일시",
        key: "body.subInfo.재해일시",
      },
      {
        name: "재해유형",
        key: "body.subInfo.재해형태",
      },
      {
        name: "복직일",
        key: "body.subInfo.복직일",
      },
      {
        name: "안전보건 위원회",
        key: "body.subInfo.안전보건위원회",
      },
      {
        name: "노무 위원회",
        key: "body.subInfo.노무위원회",
      },
      {
        name: "징계결과",
        key: "body.subInfo.징계결과",
      }
    ];
  },
  getCol: (index, value, func) => {
    try {
      const postContent = JSON.parse(value.post_content);
      switch (index) {
        case 0: {
          const header = postContent.header
          return header.year; // 대상년도
        }
        case 1:
          return func.getContent(value).stdInfo.field_name; // 사업장명
        case 2:
          return func.getContent(value).subInfo.구분; // 재해자명
        case 3:
          return func.getContent(value).subInfo.이름; // 재해자명
        case 4:
          return func.getContent(value).subInfo.팀명_업체명; // 팀명/업체명
        case 5:
          return func.getContent(value).subInfo.재해일시; // 재해 일시
        case 6:
          return func.getContent(value).subInfo.재해형태; // 재해유형
        case 7:
          return func.getContent(value).subInfo.복직일; // 복직일
        case 8: {
          const 안전보건위원회 = func.getContent(value).subInfo.안전보건위원회;
          return 안전보건위원회.승인여부 ? `${안전보건위원회.승인여부} (${안전보건위원회.날짜})` : '-' // 안전보건 위원회
        }
        case 9: {
          const 노무위원회 = func.getContent(value).subInfo.노무위원회;
          return 노무위원회.승인여부 ? `${노무위원회.승인여부} (${노무위원회.날짜})` : '-' // 안전보건 위원회
        }
        case 10: {
          const 징계결과 = func.getContent(value).subInfo.징계결과;
          const getUnit = (구분) => {
            if (구분 === '견책') return '회'
            if (구분 === '근신') return '일'
            if (구분 === '감봉') return '회'
            if (구분 === '정직') return '개월'
            return 'N/A'
          }
          return 징계결과.구분 ? `${징계결과.구분} ${징계결과.value}${getUnit(징계결과.구분)}` : '-' // 징계결과
        }
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
